import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { AuthenticationService } from './shared/_services/authentication.service';
import { ROLES } from './shared/mockups/roles.mockup';
import { User } from './shared/models/user.model';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent {
  title = 'app';
  currentUser: User;

  public destroyed = new Subject<any>();

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) {
    this.authenticationService.currentUser.subscribe(x => this.currentUser = x);

    //// override the route reuse strategy
    //this.router.routeReuseStrategy.shouldReuseRoute = function () {
    //  return false;
    //}

    //this.router.events.subscribe((evt) => {
    //  if (evt instanceof NavigationEnd) {
    //    // trick the Router into believing it's last link wasn't previously loaded
    //    debugger;
    //    this.router.navigated = false;
    //  }
    //});
  }




}
